import React, { useRef } from 'react';
import SigmaLogoSvg from '../../assets/images/landing/sigmaLogo.svg';
import ShopSolidSvg from '../../assets/images/landing/shop-solid.svg';
import LogoWhiteSvg from '../../assets/images/landing/logoWhite.svg';
import {Link} from 'react-router-dom';

function Navbar() {

  const subNav = useRef();

  function toggleNavbar(e) {
    let target = event.target;
    if (e.target.className !== 'hamburgerButton') {
        target = event.target.parentElement;
    }

    if (target.className.includes('active')) {
      target.classList.remove('active');
      subNav.current.classList.remove('active');
    } else {
      target.classList.add('active');
      subNav.current.classList.add('active');
    }
    
  }

  return (
    <div className="flexColumnContainer">
      <div className="actionContentBox">
        <div className="featuresLink">
          <Link to={"/home"}>
            <picture>
              <source type="image/svg+xml" media="(min-width: 576px)" srcSet={LogoWhiteSvg} />
              <source type="image/svg+xml" media="(max-width: 576px)" srcSet={LogoWhiteSvg} />
              <img src={LogoWhiteSvg} className="featureImage user-select-none" draggable="false" alt="Adcropper Logo" />
            </picture>
          </Link>
          <div className="navLinkContainer">
            <div className="subNavContainer" ref={subNav}>
              <Link className="text1" to={"/home"}>Home</Link>
              <Link className="text1" to={"/features"}>Features</Link>
              {/* <a className="contactUsLink" href="./contact">Contact Us</a>
              <a className="companyLink" href="./privacy">Privacy</a> */}
              <Link className="signInLink" to={"/login"} target="_blank">Sign in</Link>
            </div>

            <Link className="bookDemoButton" to={"/book-demo"}>
              Book a demo
            </Link>
            <button className="hamburgerButton" onClick={toggleNavbar}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
